import * as React from 'react';
import RangeSlider from '../../../../../../components/RangeSlider/RangeSlider';
import { Placement } from '../../../../../../components/ToolTip/IToolTip';
import ToolTip from '../../../../../../components/ToolTip/ToolTip';
import { IMaterialDataSlidersProps } from './IMaterialDataSliders';
import './MaterialDataSliders.scss';
import { useTranslation } from 'react-i18next';

const MaterialDataSliders = (props: IMaterialDataSlidersProps) => {
    const { t } = useTranslation();
    const [update, setUpdate] = React.useState<boolean>(false);

    let rf: number = props.defaultValueRf;
    let time: number = props.defaultValueTime;

    const ReductionFactory: React.ReactNode = (
        <>
            <h5>{t('material_rf_tooltip_title')}</h5>
            <p>{t('material_rf_tooltip_description')}</p>
        </>
    );
    const FloodDuration: React.ReactNode = (
        <>
            <h5>{t('material_time_tooltip_title')}</h5>
            <p>{t('material_time_tooltip_description')}</p>
        </>
    );

    const runCalculationShearStress = () => {
        let allowedShearStress = 0;
        if (props.isVegetated) {
            allowedShearStress = (1074.6 * Math.exp(-0.02 * time)) / rf;
        } else {
            allowedShearStress = 142.47 * Math.exp(-0.035 * time);
        }
        return allowedShearStress;
    };

    const handleRangeSlider = (event: Event, value: number | number[], activeThumb: number) => {
        if ((event.target as HTMLInputElement).name === 'rf') {
            rf = value as number;
        } else {
            time = value as number;
        }
        props.onChange(runCalculationShearStress(), rf, time);
        setUpdate(!update);
    };

    return (
        <>
            <div id='sliders' className='d-flex justify-content-between'>
                {props.isVegetated && (
                    <div className='slider'>
                        <div className='rangeSlider'>
                            <RangeSlider step={props.stepRf} max={props.maxRf} min={props.minRf} defaultValue={props.defaultValueRf} name='rf' onChange={handleRangeSlider} />
                        </div>
                        <ToolTip title={ReductionFactory} placement={Placement.top}>
                            <i className='fa-sharp fa-solid fa-circle-info fs-5' />
                        </ToolTip>
                        <label>{t('material_rf')}:</label>
                        <label style={{ width: '30px' }}>{rf}</label>
                    </div>
                )}
                <div className='slider'>
                    <div className='rangeSlider'>
                        <RangeSlider step={props.stepTime} max={props.maxTime} min={props.minTime} defaultValue={props.defaultValueTime} name='time' onChange={handleRangeSlider} />
                    </div>
                    <ToolTip title={FloodDuration} placement={Placement.top}>
                        <i className='fa-sharp fa-solid fa-circle-info fs-5' />
                    </ToolTip>
                    <label>{t('material_time', { unit_measure: 'h' })}: </label>
                    <label style={{ width: '30px' }}>{time}</label>
                </div>
            </div>
        </>
    );
};

export default MaterialDataSliders;
